import Swiper from 'swiper';

// Swiper Default slider
const init = function(swiperId, swiperIdContent) {
  const heroSwiper = new Swiper(swiperId, {
    slidesPerView: 1,
    loop: true,
    preloadImages: false,
    lazy: {
      loadOnTransitionStart: true,
    },
    speed: 500,
    allowTouchMove: false,
    normalizeSlideIndex: false,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    watchSlidesProgress: true,
    keyboard: {
      enabled: true,
    },
    on: {
      progress: function() {
        const swiper = this;
        const interleaveOffset = 1;
        for (let i = 0; i < swiper.slides.length; i++) {
          const slideProgress = swiper.slides[i].progress;
          const innerOffset = swiper.width * interleaveOffset;
          const innerTranslate = slideProgress * innerOffset;
          swiper.slides[i].querySelector(
            '.js-swiper-slide-inner'
          ).style.transform = 'translate3d(' + innerTranslate + 'px, 0, 0)';
        }
      },
      touchStart: function() {
        const swiper = this;
        for (let i = 0; i < swiper.slides.length; i++) {
          swiper.slides[i].style.transition = '';
        }
      },
      setTransition: function(speed) {
        const swiper = this;
        for (let i = 0; i < swiper.slides.length; i++) {
          swiper.slides[i].style.transition = speed + 'ms';
          swiper.slides[i].querySelector(
            '.js-swiper-slide-inner'
          ).style.transition = speed + 'ms';
        }
      },
    },
    pagination: {
      el: '.js-swiper-hero-pagination',
      clickable: true,
    },
  });

  const addAnimation = function(swiper) {
    const activeSlide = swiper.slides[swiper.activeIndex];
    activeSlide
      .querySelector('.swiper-hero-content__inner')
      .classList.add('overflow-anim-wrapper');
  };

  const heroSwiperContent = new Swiper(swiperIdContent, {
    slidesPerView: 1,
    loop: true,
    speed: 500,
    allowTouchMove: false,
    normalizeSlideIndex: false,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    watchSlidesProgress: true,
    keyboard: {
      enabled: true,
    },
    pagination: {
      el: '.js-swiper-hero-pagination',
      clickable: true,
    },
    on: {
      init: function() {
        const swiperInit = this;
        setTimeout(function() {
          addAnimation(swiperInit);
        }, 500);
      },
      slideChange: function() {
        const swiperSlides = Array.from(
          document.querySelectorAll('.swiper-hero-content__slide')
        );
        swiperSlides.forEach(function(slide) {
          slide
            .querySelector('.swiper-hero-content__inner')
            .classList.remove('overflow-anim-wrapper');
        });
      },
      transitionStart: function() {
        addAnimation(this);
      },
    },
  });
};

export default {
  init,
};
